import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LayoutComponent } from './components/layout/layout.component';
import { HeaderComponent } from './components/header/header.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { FooterComponent } from './components/footer/footer.component';
import { LocationManagementComponent } from './pages/location-management/location-management.component';
import { EquipmentManagementComponent } from './pages/equipment-management/equipment-management.component';
import { FileManagementComponent } from './pages/file-management/file-management.component';
import { ScheduleManagementComponent } from './pages/schedule-management/schedule-management.component';
import { DigitalSignageDisplayComponent } from './pages/digital-signage-display/digital-signage-display.component';
import { SignageEditorComponent } from './pages/signage-editor/signage-editor.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { SettingsComponent } from './pages/settings/settings.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    LayoutComponent,
    HeaderComponent,
    SidenavComponent,
    FooterComponent,
    LocationManagementComponent,
    EquipmentManagementComponent,
    FileManagementComponent,
    ScheduleManagementComponent,
    DigitalSignageDisplayComponent,
    SignageEditorComponent,
    UserManagementComponent,
    SettingsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
